var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 90H15V96H105V90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 99H15V105H105V99Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54H76C72.14 54 69 50.86 69 47V40C69 36.14 72.14 33 76 33H83C86.86 33 90 36.14 90 40V47C90 50.86 86.86 54 83 54ZM76 39C75.4475 39 75 39.4475 75 40V47C75 47.5525 75.4475 48 76 48H83C83.5525 48 84 47.5525 84 47V40C84 39.4475 83.5525 39 83 39H76Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90C56.3825 90 51 84.6175 51 78C51 71.3825 56.3825 66 63 66C69.6175 66 75 71.3825 75 78C75 84.6175 69.6175 90 63 90ZM63 72C59.6925 72 57 74.6925 57 78C57 81.3075 59.6925 84 63 84C66.3075 84 69 81.3075 69 78C69 74.6925 66.3075 72 63 72Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81V78C78 74.0175 76.6675 70.3325 74.2475 67.6225C71.545 64.5975 67.615 63 62.88 63H47.9975V57H62.88C69.37 57 74.85 59.2925 78.72 63.6275C81.49 66.73 83.2475 70.69 83.805 75H96.055C100.137 75 101.995 72.51 101.995 70.195V46.6675C101.995 34.17 91.3075 24 78.1725 24H47.995V18H78.1725C94.6175 18 107.995 30.86 107.995 46.6675V70.195C107.995 76.355 102.863 81 96.055 81H77.995H78Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderground);
export default __webpack_public_path__ + "static/media/Underground.66639f4b.svg";
export { ForwardRef as ReactComponent };